/*
  Rococo Sand - truthful storefront filter counts.

  Shopify's filter numbers are all arithmetically real. What was wrong was that
  two of them answer a different question than the label implies.

  1. A variant option filter counts products that HAVE a variant with that
     option, not products you can actually buy in it. Every style carries the
     full XXS-XXL run, so every size reported the entire collection (16 of 16).
     Shopify will only give a purchasable count when filter.v.availability=1 is
     applied too, so this script refetches the same result set that way and
     patches the real numbers in.

  2. filter.v.availability is variant level. Value 0 means "has at least one
     sold out size", not "is out of stock", which is why it read 15 on a 16
     product page. The count is correct and clicking it really does return 15,
     so the fix is the label, not the number. Nothing in this catalogue is
     fully sold out, so a literal out of stock filter would read (0) on every
     collection and be useless.

  While that filter is on it also rewrites each card's action row: the size
  list swaps from the sizes still in stock to the sold out ones, and Add to bag
  becomes a disabled Out of stock, because every size on show is unbuyable. The
  data comes from #RsSoldOutSizes, emitted by snippets/collection-grid.liquid.

  Degrades quietly: if the fetch fails the size counts are left as Shopify sent
  them and nothing else on the page changes.
*/
(function () {
  'use strict';

  if (window.rsFilterCounts) return;
  window.rsFilterCounts = true;

  var OPTION = 'filter.v.option.';
  var AVAIL = 'filter.v.availability';
  var VIEW = 'rs-filter-counts';
  var IN_STOCK_LABEL = 'In stock';
  var SOLD_OUT_LABEL = 'Sold-out sizes';
  var SOLD_OUT_BUTTON = 'Out of stock';
  var SHOPIFY_SOLD_OUT = 'out of stock';
  var HAS_COUNT = /\(\s*\d+\s*\)/;

  // Client asked for the Size group to read as plain size names, with no
  // number beside them. The corrected counts are still computed and still
  // drive the hiding of sizes nothing is purchasable in - they are only kept
  // out of sight. Widen this to /^filter\.v\.option\./i to silence every
  // option group, or set HIDE_COUNTS to null to show them all again.
  var HIDE_COUNTS = /^filter\.v\.option\.size$/i;

  var cache = {};
  var observer = null;
  var timer = null;
  var patching = false;

  function params() {
    return new URLSearchParams(window.location.search);
  }

  function optionInputs() {
    return document.querySelectorAll('input.tag__input[name^="' + OPTION + '"]');
  }

  function availInputs(value) {
    return document.querySelectorAll('input[name="' + AVAIL + '"][value="' + value + '"]');
  }

  // The theme renders each value as
  //   <li><label><input><span class="tag__checkbox"></span>
  //   <span><span class="tag__text">XXS</span> (16)</span></label></li>
  // so the count is a bare text node sitting after .tag__text.
  function parts(input) {
    var li = input.closest('li');
    var text = li && li.querySelector('.tag__text');
    if (!li || !text || !text.parentNode) return null;
    return {
      li: li,
      text: text,
      wrap: text.parentNode,
      count: li.querySelector('.tag__count')
    };
  }

  function trailing(p) {
    if (p.count) return p.count.textContent || '';
    var out = '';
    var node = p.text.nextSibling;
    while (node) {
      out += node.textContent || '';
      node = node.nextSibling;
    }
    return out;
  }

  function setTrailing(p, value) {
    if (p.count) {
      p.count.textContent = value || '';
      return;
    }
    while (p.text.nextSibling) p.wrap.removeChild(p.text.nextSibling);
    if (value) p.wrap.appendChild(document.createTextNode(value));
  }

  // A bare text node cannot be styled or hidden, so move the count into a
  // span the first time we see it. Everything downstream addresses that span
  // instead, which is why setTrailing no longer blows the wrapper away.
  function wrapCount(p) {
    if (p.count) return p.count;

    var span = document.createElement('span');
    span.className = 'tag__count';

    var node = p.text.nextSibling;
    while (node) {
      var next = node.nextSibling;
      span.appendChild(node);
      node = next;
    }

    p.wrap.appendChild(span);
    p.count = span;
    return span;
  }

  // Hide the number, keep the label. Inline style rather than a stylesheet
  // rule so the whole behaviour lives in this one file.
  function hideCounts() {
    if (!HIDE_COUNTS) return;

    var inputs = optionInputs();
    for (var i = 0; i < inputs.length; i++) {
      if (!HIDE_COUNTS.test(inputs[i].name)) continue;

      var p = parts(inputs[i]);
      if (!p || !HAS_COUNT.test(trailing(p))) continue;

      var span = wrapCount(p);
      span.classList.add('tag__count--hidden');
      span.style.display = 'none';
    }
  }

  function guard(fn) {
    patching = true;
    try { fn(); } catch (e) {}
    setTimeout(function () { patching = false; }, 0);
  }

  // Labels only. Both counts stay exactly as Shopify sent them, because both
  // match what clicking actually returns. Needs no fetch, so it lands before
  // first paint.
  function relabelAvailability() {
    var stocked = availInputs('1');
    var sold = availInputs('0');
    var i, p;

    for (i = 0; i < stocked.length; i++) {
      p = parts(stocked[i]);
      if (p) p.text.textContent = IN_STOCK_LABEL;
    }

    for (i = 0; i < sold.length; i++) {
      p = parts(sold[i]);
      if (p) p.text.textContent = SOLD_OUT_LABEL;
    }

    // The removable chips above the form are a separate loop over
    // filter.active_values, so they carry Shopify's wording too.
    var chips = document.querySelectorAll('.tag--remove a');
    for (i = 0; i < chips.length; i++) {
      if ((chips[i].textContent || '').trim().toLowerCase() === SHOPIFY_SOLD_OUT) {
        chips[i].textContent = SOLD_OUT_LABEL;
      }
    }
  }

  function soldOutViewActive() {
    var active = false;
    params().forEach(function (value, key) {
      if (key === AVAIL && value === '0') active = true;
    });
    return active;
  }

  // While the shopper is asking to see sold out sizes, show them exactly that
  // on the card instead of the sizes still in stock, and kill the buy button:
  // every size on display is unbuyable, so Add to bag would be a lie.
  function showSoldOutSizes() {
    if (!soldOutViewActive()) return;

    var source = document.getElementById('RsSoldOutSizes');
    if (!source) return;

    var data;
    try { data = JSON.parse(source.textContent || '{}'); } catch (e) { return; }

    var rows = document.querySelectorAll('.collection-grid__wrapper .grid-action-variants');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (row.getAttribute('data-rs-sold') === '1') continue;

      var card = row.closest('.grid__item');
      var link = card && card.querySelector('a[href*="/products/"]');
      if (!link) continue;

      var handle = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      var sizes = handle && data[handle[1]];
      if (!sizes || !sizes.length) continue;

      row.setAttribute('data-rs-sold', '1');
      row.innerHTML = '';
      for (var j = 0; j < sizes.length; j++) {
        var span = document.createElement('span');
        span.className = 'grid-size-btn grid-size-btn--sold';
        span.textContent = sizes[j];
        row.appendChild(span);
      }

      var actionRow = row.parentElement;
      var addBtn = actionRow && actionRow.querySelector('.grid-add-btn');
      if (!addBtn) continue;

      addBtn.disabled = true;
      addBtn.setAttribute('aria-disabled', 'true');
      addBtn.classList.add('grid-add-btn--sold');
      var addText = addBtn.querySelector('.grid-add-text');
      if (addText) addText.textContent = SOLD_OUT_BUTTON;
    }
  }

  // Once the shopper has picked any variant level filter, Shopify's own option
  // counts are already scoped to it and agree with the grid, so leave them be.
  // The override is only needed on the untouched view, where every size claims
  // the whole collection.
  function shouldOverride() {
    var untouched = true;
    params().forEach(function (value, key) {
      if (key === AVAIL || key.indexOf(OPTION) === 0) untouched = false;
    });
    return untouched;
  }

  function countsUrl() {
    var query = params();
    query.delete('view');
    query.delete('section_id');
    query.delete('page');
    query.delete(AVAIL);
    query.append(AVAIL, '1');
    query.append('view', VIEW);
    return window.location.pathname + '?' + query.toString();
  }

  function load() {
    var url = countsUrl();
    if (cache[url]) return Promise.resolve(cache[url]);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (body) {
        var data = JSON.parse(body);
        cache[url] = data;
        return data;
      });
  }

  function paint(data) {
    var inputs = optionInputs();

    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var group = data[input.name];
      if (!group) continue;

      var count = group[input.value];
      if (typeof count !== 'number') continue;

      var p = parts(input);
      // Only rewrite values that already show a count, which leaves colour
      // swatches and image filters exactly as they were.
      if (!p || !HAS_COUNT.test(trailing(p))) continue;

      setTrailing(p, ' (' + count + ')');
      if (count === 0) p.li.classList.add('hide');
      else p.li.classList.remove('hide');
    }
  }

  function run() {
    guard(function () {
      relabelAvailability();
      hideCounts();
      showSoldOutSizes();
    });

    if (!shouldOverride() || !optionInputs().length) return;
    load()
      .then(function (data) {
        guard(function () { paint(data); });
      })
      .catch(function () {});
  }

  function schedule() {
    if (patching) return;
    clearTimeout(timer);
    timer = setTimeout(run, 150);
  }

  // The theme swaps out #CollectionAjaxContent, sidebar included, on every
  // filter change, so re-apply after each render.
  function watch() {
    if (!observer) observer = new MutationObserver(schedule);
    observer.observe(document.querySelector('.collection-content') || document.body, {
      childList: true,
      subtree: true
    });
  }

  function onToggle(event) {
    var input = event.target;
    if (!input || input.type !== 'checkbox' || !input.checked) return;

    var form = input.form || input.closest('form');
    if (!form) return;

    // In stock and sold-out sizes are opposite questions. Left as plain
    // checkboxes Shopify ORs them together and hands back everything, so keep
    // them mutually exclusive.
    if (input.name === AVAIL) {
      var all = form.querySelectorAll('input[name="' + AVAIL + '"]');
      for (var i = 0; i < all.length; i++) {
        if (all[i] !== input) all[i].checked = false;
      }
      return;
    }

    if (input.name.indexOf(OPTION) !== 0) return;

    // Picking a size with no availability chosen means the shopper wants that
    // size, so constrain to in stock and the grid matches the count they just
    // read. An explicit choice, including sold-out sizes, is left alone: that
    // pairing is exactly how you ask "which dresses are gone in my size".
    if (form.querySelector('input[name="' + AVAIL + '"]:checked')) return;
    var inStock = form.querySelector('input[name="' + AVAIL + '"][value="1"]');
    if (inStock) inStock.checked = true;
  }

  // On window and in capture phase, because the theme serialises the form from
  // its own handler: a checkbox fires click before change, and window captures
  // before document, so this is the only ordering that lands first. Bound to
  // both events and idempotent, so a double fire costs nothing.
  window.addEventListener('click', onToggle, true);
  window.addEventListener('change', onToggle, true);

  window.addEventListener('popstate', schedule);

  function init() {
    run();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
